/* =================================
   FRETE INFORMATIVO – LOJA MORELA
   Versão Estável Shopify 2.0
   ================================= */

function initFrete() {
  const cepInput = document.getElementById("shipping-cep");
  const button = document.getElementById("shipping-calc-button");
  const address = document.getElementById("shipping-address");
  const table = document.getElementById("shipping-table");

  if (!cepInput || !button) return;

  let carregando = false;

  function calcularFrete() {
    if (carregando) return;

    let cep = cepInput.value.replace(/\D/g, "");
    if (cep.length !== 8) {
      alert("Por favor, digite um CEP válido com 8 dígitos.");
      return;
    }

    carregando = true;
    button.disabled = true;
    button.textContent = "Calculando...";

    // Limpa resultados anteriores
    if (address) address.style.display = "none";
    if (table) {
      table.innerHTML = `
        <div class="shipping-row shipping-header">
          <span>Entrega</span>
          <span>Prazo</span>
          <span>Preço</span>
        </div>
      `;
      table.style.display = "none";
    }

    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then(response => response.json())
      .then(data => {
        if (data.erro) {
          alert("CEP não encontrado");
          return;
        }

        if (address) {
          address.textContent = `${data.logradouro} - ${data.localidade} - ${data.uf}`;
          address.style.display = "block";
        }

        // Lógica de Detecção baseada no Payload do Liquid
        // Mudança aqui: Iniciamos como false para não forçar o "Nacional" por engano
        const payload = window.cartPayload || { hasNational: false, hasInternational: false };
        let fretesParaExibir = [];

        // 1. PRIORIDADE: MISTO (Híbrido)
        if (payload.hasNational && payload.hasInternational) {
          fretesParaExibir.push({
            nome: "Envio Híbrido",
            detalhe: "2 Remessas separadas",
            prazo: "5 a 20 dias",
            preco: "GRÁTIS"
          });
        } 
        // 2. APENAS INTERNACIONAL
        else if (payload.hasInternational) {
          fretesParaExibir.push({
            nome: "Envio Internacional",
            detalhe: "Entrega Segura",
            prazo: "15 a 20 dias",
            preco: "GRÁTIS"
          });
        } 
        // 3. APENAS NACIONAL (ou padrão)
        else {
          fretesParaExibir.push({
            nome: "Envio Nacional",
            detalhe: "Entrega Rápida",
            prazo: "5 a 12 dias",
            preco: "GRÁTIS"
          });
        }

        if (table) {
          fretesParaExibir.forEach(frete => {
            const row = document.createElement("div");
            row.classList.add("shipping-row");
            row.innerHTML = `
              <div style="display:flex; flex-direction:column; text-align:left;">
                <span style="font-weight:600;">${frete.nome}</span>
                <small style="font-size:10px; color:#666;">${frete.detalhe}</small>
              </div>
              <span>${frete.prazo}</span>
              <span style="color:#2d8a39; font-weight:bold;">${frete.preco}</span>
            `;
            table.appendChild(row);
          });
          table.style.display = "block";
        }
      })
      .catch(() => {
        alert("Erro ao consultar o CEP");
      })
      .finally(() => {
        carregando = false;
        button.disabled = false;
        button.textContent = "Calcular";
      });
  }

  // Ativa os gatilhos
  button.onclick = calcularFrete;
  cepInput.addEventListener("keypress", function(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      calcularFrete();
    }
  });
}

// Inicialização segura para o Shopify
document.addEventListener("DOMContentLoaded", initFrete);
document.addEventListener("shopify:section:load", initFrete);